import type { Action } from 'redux'
import type { InvokeDefinition } from '../../signalr/types'
import { defaultGetParams as getParams } from '../../signalr/helpers'
import {
  type CreateOrUpdateAlertFilterAction,
  type DeleteAlertFilterAction,
  type MuteAlertFilterAction,
  createOrUpdateAlertFilterSuccess,
  deleteAlertFilterSuccess,
  fetchAlertFiltersSuccess,
  muteAlertFilterSuccess
} from './actions'
import type { AlertFilter } from './types'

export const fetchAlertFiltersDefinition: InvokeDefinition<
  [],
  AlertFilter[],
  Action
> = {
  method: 'GetAlertFilters',
  getParams,
  mapResponse: fetchAlertFiltersSuccess
}

export const createOrUpdateAlertFilterDefinition: InvokeDefinition<
  [AlertFilter],
  number,
  CreateOrUpdateAlertFilterAction
> = {
  method: 'CreateOrUpdateAlertFilter',
  getParams: (_state, action) => [action.payload.alertFilter],
  mapResponse: createOrUpdateAlertFilterSuccess
}

export const deleteAlertFilterDefinition: InvokeDefinition<
  [number],
  number,
  DeleteAlertFilterAction
> = {
  method: 'DeleteAlertFilter',
  getParams: (_state, action) => [action.payload.id],
  mapResponse: deleteAlertFilterSuccess
}

export const muteAlertFilterDefinition: InvokeDefinition<
  [number, boolean],
  AlertFilter,
  MuteAlertFilterAction
> = {
  method: 'MuteAlertFilter',
  strategy: 'switch',
  getParams: (_state, action) => [action.payload.id, action.payload.mute],
  mapResponse: muteAlertFilterSuccess
}
